import { TaxForm, UploadedCollectionTaxForm, UploadedTaxDocument, UploadedTaxDocumentCollection, UploadedTaxDocumentCollectionItem, UploadedTaxForm } from "./tax_document";
import { SaveTaxReturnResponse } from "./tax_return";

export interface IRSW2Form extends TaxForm {
    local_withholdings: LocalWithholding[] | null;
    wages_tips_other_comp_box1: number | string | null;
    medicare_wages_and_tips: number | string | null;
    employer_tax_id?: number | string | null;
    is_third_party_sick_pay?: boolean | string | null; // Backend apparently sends strings "true"/"false"
    employer_name: string | null;
    employer_address: EmployerAddress | null;
    document_owner: DocumentOwner | null
}

export enum DocumentOwner {
    Self = "self",
    Spouse = "spouse"
}

export interface IRSW2FormCollectionItem extends UploadedTaxDocumentCollectionItem, IRSW2Form {}

export interface UploadedIRSW2Form extends UploadedTaxForm<IRSW2Form> {}

export interface LocalWithholding {
    local_income_tax: number;
    local_wages_and_tips: number;
    locality_name?: string;
}

export interface EmployerAddress {
    address_1: string;
    address_2: string;
    city: string;
    state: string;
    zip_code: string;
}

export const emptyW2Form: IRSW2FormCollectionItem = {
    id: -1,
    file_name: "",
    file_storage_url: "",
    local_withholdings: [],
    wages_tips_other_comp_box1: "",
    medicare_wages_and_tips: "",
    employer_tax_id: "",
    employer_name: "",
    is_third_party_sick_pay: false,
    employer_address: {
        name: "",
        address_1: "",
        address_2: "",
        city: "",
        state: "",
        zip_code: ""
    },
    document_owner: DocumentOwner.Self
};

export interface UploadedW2Document extends UploadedTaxDocument<UploadedIRSW2Form> {}

export interface UploadedW2DocumentCollection extends UploadedTaxDocumentCollection<IRSW2FormCollectionItem> {}

export interface SaveW2Response extends UploadedW2Document, SaveTaxReturnResponse {};

export interface SaveW2CollectionResponse extends UploadedW2DocumentCollection, SaveTaxReturnResponse {};

export function validateLocalWithholding(lwh: LocalWithholding): boolean {
    // local_wages_and_tips can be null if local_income_tax and locality_name are provided)
    return (!!lwh.local_income_tax == !!lwh.locality_name);
}

export function validateEmployerAddress(address: EmployerAddress): boolean {
    return !!address.address_1
        && !!address.city
        && !!address.state
        && !!address.zip_code;
}

export function validateIRSW2Form(form: IRSW2Form): boolean {
    return !!form.wages_tips_other_comp_box1
        && !!form.medicare_wages_and_tips
        && !!form.employer_name
        && !!form.employer_address
        && !!form.employer_tax_id
        && validateEmployerAddress(form.employer_address)
        && (form.local_withholdings?.every(validateLocalWithholding) ?? true);
}
